export const GET_USERS = "GET_USERS"
export const DELETE_USER  = "DELETE_USER"